module.exports = __webpack_public_path__ + "static/media/infectious.f5418e81.mp3";